import React from "react";
import {
  useLocation,
  matchPath,
  Link,
  useParams,
  generatePath,
} from "react-router";
import {StrMap} from "../../interfaces/common";
import ChevronRightIcon from "../Icons/ChevronRightIcon";
import { useTranslation } from "react-i18next";

interface Props {
  breadcrumbConfig: Array<StrMap>;
}

const Breadcrumbs: React.FC<Props> = ({ breadcrumbConfig }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const params = useParams();
  const { pathname } = location;

  if (pathname.startsWith("/feedback/questionnaire/")) {
    return null;
  }

  const breadcrumbs = breadcrumbConfig
    .filter(({ path }) => matchPath({ path, end: false }, pathname))
    .map(({ path, breadcrumbKey }) => ({
      path: generatePath(path, params),
      breadcrumb: t(breadcrumbKey),
    }));

  if (breadcrumbs.length < 3) {
    return null;
  }

  return (
    <nav aria-label="breadcrumb" className="z-breadcrumbs">
      <div className="flex flex-col justify-start align-middle w-full mx-auto desktop:w-151">
        <ol className="flex flex-wrap items-center text-gray-400 text-xs">
          {breadcrumbs.map((crumb, index) => (
            <li key={index} className="flex items-center">
              <Link to={crumb.path} className="hover:text-primary-500">
                {crumb.breadcrumb}
              </Link>
              {index < breadcrumbs.length - 1 && (
                <ChevronRightIcon className="w-4 h-4 mx-1.5 text-neutral-400!" aria-hidden="true" />
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
